import {
  FillInTheBlanksAreaPinComponentWrapper,
  FillInTheBlanksTiptapViewer,
  FillInTheBlanksWordBank,
} from '@lessonup/pin-renderer';
import { FillInTheBlanksAreaPinComponentSettings, recreateTipTapContent } from '@lessonup/pins-shared';
import { useCurrentPin, useCurrentViewByType } from '@lessonup/players-modern';
import { styled } from '@lessonup/ui-components';
import React from 'react';

interface FillInTheBlanksPinComponentRealtimePlayerProps {
  pinId: string;
  pinComponentId: string;
  settings: FillInTheBlanksAreaPinComponentSettings;
}

export const FillInTheBlanksAreaRealtimePlayer: React.FC<FillInTheBlanksPinComponentRealtimePlayerProps> = ({
  settings,
}) => {
  const currentPin = useCurrentPin();
  const currentView = useCurrentViewByType('FILL_IN_THE_BLANKS');
  if (!currentPin) {
    return null;
  }

  if (currentPin.type !== 'FILL_IN_THE_BLANKS') {
    return null;
  }

  const tipTapContent =
    currentView?.phase === 'results'
      ? recreateTipTapContent(settings.tipTapContent ?? {}, currentPin.teacherSettings.correctAnswers)
      : settings.tipTapContent;

  return (
    <FillInTheBlanksAreaPinComponentWrapper settings={settings}>
      <StyledAreaPinComponentWrapper>
        <StyledTipTapWrapper style={{ backgroundColor: settings.backgroundColor }}>
          <FillInTheBlanksTiptapViewer content={tipTapContent ?? {}} />
        </StyledTipTapWrapper>
        {currentView?.phase !== 'results' && (
          <StyledWordBankWrapper>
            <FillInTheBlanksWordBank
              items={currentPin.settings.wordBank.map((word) => ({
                type: 'blank',
                word: word,
              }))}
            />
          </StyledWordBankWrapper>
        )}
      </StyledAreaPinComponentWrapper>
    </FillInTheBlanksAreaPinComponentWrapper>
  );
};

const StyledAreaPinComponentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  padding: 4px;
`;

const StyledTipTapWrapper = styled.div`
  flex: 1;
  width: 100%;
  min-height: 0;
  margin-bottom: 4px;
  border-radius: 8px;
  padding: 10px;
  overflow-y: auto;
`;

const StyledWordBankWrapper = styled.div`
  width: 100%;
  overflow-y: auto;
  max-height: 40%;
`;
